import PropTypes from 'prop-types';
import { BottomSheet } from 'react-spring-bottom-sheet';

import 'react-spring-bottom-sheet/dist/style.css';

export default function BottomSheetComponent({ children, open, onDismiss }) {
  return (
    <BottomSheet open={open} onDismiss={onDismiss}>
      {children}
    </BottomSheet>
  );
}

BottomSheetComponent.propTypes = {
  children: PropTypes.node,
  onDismiss: PropTypes.func,
  open: PropTypes.bool,
};
